import React from 'react';
import {
  CategorizedContentMinimalistic,
  CategorizedContentMinimalisticProps,
} from '../../CategorizedContent/CategorizedContentMinimalistic';
import { HeaderToItems } from '../../CategorizedContent/typesCategorizedContent';
import { HeaderWithItemsNodesAndIndices } from '../typesSearchAsYouType';

export const remappedCategorizedContentMinimalisticFactory: (
  props: Omit<CategorizedContentMinimalisticProps, 'content' | 'forceHideHeaders'>,
) => React.FC<{
  content: HeaderWithItemsNodesAndIndices[];
  forceHideHeaders: boolean;
  onAllAndNonzeroNodesHidden?: React.ReactNode;
  onItemClicked: (arg: { id: string }) => void;
}> = props => {
  const { items, ...restProps } = props;
  return ({ content, forceHideHeaders, onItemClicked, onAllAndNonzeroNodesHidden }) => {
    const remappedContent: HeaderToItems[] = content.map(
      ({ header: { hidden: headerHidden, id: headerId, idx, value: headerValue }, items: itemNodes }) => ({
        headerContent: {
          hidden: headerHidden,
          id: headerId,
          idx,
          insideNode: headerValue,
          key: `${headerValue}__${idx}`,
        },

        itemsContent:
          itemNodes && itemNodes.length > 0
            ? itemNodes.map(item => {
                const { hidden: itemHidden, id: itemId, idx: itemIdx, selected, value: itemValue } = item;

                return {
                  hidden: itemHidden,
                  id: itemId,
                  idx: itemIdx,
                  insideNode: itemValue,
                  key: `${headerValue}__${itemValue}__${itemIdx}`,
                  selected,
                };
              })
            : [],
      }),
    );

    return (
      <CategorizedContentMinimalistic
        content={remappedContent}
        forceHideHeaders={forceHideHeaders}
        items={{ ...items, onClick: onItemClicked }}
        onAllAndNonzeroNodesHidden={onAllAndNonzeroNodesHidden}
        {...restProps}
      />
    );
  };
};
